export const categories = [
  {
    id: 1,
    slug: 'shipin-fuli',
    name: '视频福利',
    description: '精选视频平台会员、观影券、点播福利资源，海量高清影视内容一站畅享',
    icon: 'ri-movie-2-line',
    count: 128,
    featured: true,
  },
  {
    id: 2,
    slug: 'youhuiquan',
    name: '优惠券',
    description: '各大电商平台优惠券、满减券、折扣码实时更新，购物省钱必备攻略',
    icon: 'ri-coupon-2-line',
    count: 256,
    featured: true,
  },
  {
    id: 3,
    slug: 'youxi-fuli',
    name: '游戏福利',
    description: '热门游戏礼包、激活码、充值折扣、游戏道具免费领，玩家福利集中营',
    icon: 'ri-gamepad-line',
    count: 89,
    featured: true,
  },
  {
    id: 4,
    slug: 'gouwu-fanli',
    name: '购物返利',
    description: '购物返利平台精选，下单即返现，网购达人省钱秘籍尽在掌握',
    icon: 'ri-shopping-bag-3-line',
    count: 156,
    featured: true,
  },
  {
    id: 5,
    slug: 'jinrong-fuli',
    name: '金融福利',
    description: '信用卡权益、理财红包、保险福利、支付优惠，金融生活好礼不间断',
    icon: 'ri-bank-line',
    count: 72,
    featured: false,
  },
  {
    id: 6,
    slug: 'huiyuan-fuli',
    name: '会员福利',
    description: '各大平台会员权益汇总，免费试用、积分兑换、会员专属折扣应有尽有',
    icon: 'ri-vip-crown-line',
    count: 198,
    featured: true,
  },
  {
    id: 7,
    slug: 'shenghuo-fuwu',
    name: '生活服务',
    description: '外卖红包、出行优惠、生活缴费折扣、本地生活福利一网打尽',
    icon: 'ri-service-line',
    count: 145,
    featured: false,
  },
  {
    id: 8,
    slug: 'jiaoyu-ziyuan',
    name: '教育资源',
    description: '在线课程优惠、学习资料分享、知识付费折扣，自我提升更轻松',
    icon: 'ri-book-open-line',
    count: 63,
    featured: false,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};

export const getCategoryById = (id: number) => {
  return categories.find((c) => c.id === id);
};